import {createUndoMiddleware} from 'redux-undo-redo'
import {addScene, removeScene, deleteItem, addBulkObjects, moveUpdate, undoMove, updateTextFormats, updateSlide, changeAction, changeExpression, applyFilter, deleteObject, changeObjectThumb, updateSVGColor, flipItem, cropBG, changeBGThumbValue, unGroupObjects, groupObjects, onItemDrag, changeText, updateObject, writeText, addPrebuilt, addObj, updateScene, updateSVGTheme, saveProjectName, undoScenePaste,applyAllTransition, setAnimateValue, applyEnterEffect , moveScene} from './actions'
import { fromJS } from 'immutable';

export default createUndoMiddleware( 
  {
  revertingActions: {
      
    'ADD_SCENE': {
      action: function(action, {index}) {
        return removeScene(index, action.socket)
      },
      createArgs: (state, {id}) => {
        const index = state.localStore.get("selectedScene") + 1;
        return {
          index
        }
      }
    },

    "REMOVE_SCENE": {
      action: function(action, meta) {
        return addScene(meta, action.socket)
      },
      createArgs: (state, action) => {
        const selectedScene = state.localStore.get("selectedScene") - 1;
        const slide = state.project.getIn(["scenes", action.data]);
       
        return {
          selectedScene, slide
        }
      }
    },
    'MOVE_SCENE': {
      action: function(action, {oldIdx, newIdx}) {
        return moveScene(oldIdx, newIdx, action.socket)
      },
      meta: (state, action) => {
        return {
          oldIdx : action.oldIndex,
          newIdx : action.newIndex
        }
      }
    },

    "DUPLICATE_SCENE" : {
      action: function(action, {index}) {
        return removeScene(index, action.socket)
      },
      createArgs: (state, action) => {
        const index = state.localStore.get("selectedScene") + 1;
        return {
          index
        }
      }
    },

    'MOVE_SCENE': {
      action: function(action, {oldIdx, newIdx}) {
        return moveScene(oldIdx, newIdx, action.socket)
      },
      meta: (state, action) => {
        return {
          oldIdx : action.oldIndex,
          newIdx : action.newIndex
        }
      }
    },
    "ADD_OBJECT" : {
      action: function(action, meta) {
        
        if(meta.data !== null){
          return addObj(meta.data,action.socket)
        }
        else{
          return deleteItem(meta, action.socket)
        }
      },
      createArgs: (state, action) => {
        var selectedItems = [action.data.item_id];
        var selectedScene = action.data.selectedScene;
        var data = null;
        if(action.data.type === "TXTGRP" || action.data.type === "GROUP")
          selectedItems = Object.keys(action.data.items.workspaceItems);
         
        if(action.data.emptySwap === false){
          var prevData=state.project.getIn(["scenes", selectedScene, "workspaceItems", state.localStore.getIn(["selectedItems", 0])]).toJS();
          data = prevData;
          data.emptySwap=true;
          if(action.data.subType!==prevData.subType)
          {
            if(prevData.subType==='CHR')
            {
              data.src = action.data.charId+"/"+prevData.src;
              data.src  = data.src.split('/')[1]+'/'+data.src.split('/')[2];
              data.subType=prevData.subType;
            }
            else
            {
              data.src = prevData.src;
              data.parts = prevData.parts;
              data.subType=prevData.subType;
            }
          }
          else if(action.data.subType==='CCHR')
          {
              data.subType=prevData.subType;
              data.parts = prevData.parts
          }
          if(action.data.type==='CHR' &&prevData.type==='CHR')
          {
            data.pose = prevData.pose;
            data.expression = prevData.expression;
          }
          data.item_id=state.localStore.getIn(["selectedItems", 0]);
          data.selectedScene=selectedScene;
          data.videoDuration = action.data.duration;
          if(action.data.subType === 'ECHR' && action.data.swapDetails.subType === 'CHR'){
            if(action.data.checkAudio.length){
                data.voiceOverData = action.data.voiceOverData;
                data.checkAudio = action.data.checkAudio;
            }
          }
        }
        
        return {
          data,selectedItems, selectedScene
        }
      }
    },

    "DELETE_ITEM" : {
      action: function(action, meta) {
        return addBulkObjects(meta)
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        var socket = action.socket;
        
        var selectedItems = state.project.getIn(["scenes", selectedScene, "workspaceItems"]).filter(function(obj, key){return state.localStore.get("selectedItems").keyOf(key) !== undefined;});

        var workspaceIds = [], workspaceChildIds = [], workspaceData = [], workspaceChildData = [];
        
        selectedItems.entrySeq().forEach(([key, item]) =>{
          workspaceIds.push(key); workspaceData.push(item.toJS());
          if(item.get("type") === "GROUP"){
            item.get("groupChildren").entrySeq().forEach(([index, childId]) =>{
              workspaceChildIds.push(childId); workspaceChildData.push(state.project.getIn(["scenes", selectedScene, "workspaceChildren", childId]).toJS());
            })
          }
        });

        return {
          selectedScene, workspaceIds, workspaceData, workspaceChildIds, workspaceChildData, socket
        }
      }
    },

    "MOVE_UPDATE" : {
      action: function(action, meta) {
      
        return undoMove(meta)
      },
      createArgs: (state, action) => {
        var prevData = action.data;
        var selectedScene = prevData.selectedScene;
        var currentContainer = prevData.currentContainer;
        var socket = action.socket;
        var workspaceItems = {}, workspaceChildren = {};
          prevData.selectedItems.entrySeq().forEach(([index, id]) =>{
            var item = state.project.getIn(["scenes", prevData.selectedScene, "workspaceItems", id]);
            workspaceItems[id] = { x : item.get("x"), y : item.get("y")};
            if(item.get("type") === "GROUP"){
              item.get("groupChildren").entrySeq().forEach(([index, childId]) =>{
                var childItem = state.project.getIn(["scenes", selectedScene, "workspaceChildren", childId]);
                var childToUpdate = { x : childItem.get("x"), y : childItem.get("y")};
                workspaceChildren[childId] = childToUpdate;
              })
            }
          });
        return {selectedScene, workspaceItems, workspaceChildren, currentContainer, socket};
      }
    },

    "RESIZE_UPDATE" : {
      action: function(action, meta) {
       
        return undoMove(meta)
      },
      createArgs: (state, action) => {
        
        var prevData = action.data;
        var selectedScene = prevData.selectedScene;
        var currentContainer = prevData.currentContainer;
        var socket = action.socket;
        var workspaceItems = {}, workspaceChildren = {};
          prevData.selectedItems.entrySeq().forEach(([index, id]) =>{
            var item = state.project.getIn(["scenes", prevData.selectedScene, "workspaceItems", id]);
            workspaceItems[id] = { x : item.get("x"), y : item.get("y"), width : item.get("width"), height : item.get("height")};
            

            if(item.get("type") === "TEXT" || item.get("type") === "SHAPE")
              workspaceItems[id].textData = item.get("textData").toJS();

            if(item.get("type") === "GROUP"){
              item.get("groupChildren").entrySeq().forEach(([index, childId]) =>{
                var childItem = state.project.getIn(["scenes", selectedScene, "workspaceChildren", childId]);
                workspaceChildren[childId] = { x : childItem.get("x"), y : childItem.get("y"), width : childItem.get("width"), height : childItem.get("height")};

                if(childItem.get("type") === "TEXT" || childItem.get("type") === "SHAPE")
                  workspaceChildren[childId].textData = childItem.get("textData").toJS();
                
                
              })
            }
          });
         
       
        return {selectedScene, workspaceItems, workspaceChildren, currentContainer, socket, resizing : true};
      }
    },

    "ROTATION_UPDATE" : {
      action: function(action, meta) {
        return undoMove(meta)
      },
      createArgs: (state, action) => {
        var prevData = action.data;
        var selectedScene = prevData.selectedScene;
        var currentContainer = prevData.currentContainer;
        var socket = action.socket;
        var workspaceItems = {}, workspaceChildren = {};
          prevData.selectedItems.entrySeq().forEach(([index, id]) =>{
            var item = state.project.getIn(["scenes", prevData.selectedScene, "workspaceItems", id]);
            workspaceItems[id] = { x : item.get("x"), y : item.get("y"), angle : item.get("angle")};
            

            if(item.get("type") === "GROUP"){
              item.get("groupChildren").entrySeq().forEach(([index, childId]) =>{
                var childItem = state.project.getIn(["scenes", selectedScene, "workspaceChildren", childId]);
                workspaceChildren[childId] = { x : childItem.get("x"), y : childItem.get("y"), angle : childItem.get("angle") };
              })
            }

          });

        return {selectedScene, workspaceItems, workspaceChildren, currentContainer, socket};
      }
    },

    "UPDATE_TEXT" : {
      action: function(action, meta) {
      
        return updateObject(meta, action.socket)
      },
      createArgs: (state, action) => {
       
        var selectedScene = action.data.selectedScene;
        var selectedItem = action.data.id;
        var container = action.data.container;
        let item = state.project.getIn(["scenes", selectedScene, container, selectedItem]);
        var toUpdate = {textData : item.get("textData").toJS(), width : item.get("width"), height : item.get("height")};

        if(item.get("yRatio") !== undefined)
          toUpdate.yRatio = item.get("yRatio");
        if(item.get("heightRatio") !== undefined)
          toUpdate.heightRatio = item.get("heightRatio");
      
        return {selectedScene, selectedItem, container, toUpdate};
      }
    },

    "ADD_SCENE_TRANSITION" : {
      action: function(action, meta) {
       
        return updateSlide(meta)
      },
      createArgs: (state, action) => {
        
        var slideIndex = action.slideIndex;
        var socket = action.socket;
        var value = state.project.getIn(["scenes", slideIndex, "transEffect"]);
        var sizes = state.project.getIn(["scenes", slideIndex, "sizes"]);
       
        return {slideIndex, value, sizes, socket, subType : "ADD_SCENE_TRANSITION"};
      }
    },

    "UPDATE_SCENE" : {
      action: function(action, meta) {
       
        return updateScene(meta, action.socket)
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        let toUpdate = state.project.getIn(["scenes", selectedScene]).filter((val, key)=> action.data.toUpdate[key] !== undefined).toJS();
        return {selectedScene, toUpdate};
      }
    },

    "CHANGE_ACTION" : {
      action: function(action, meta) {
        return changeAction(meta, action.id, action.selectedScene, action.socket)
      },
      createArgs: (state, action) => {
       
        var selectedItem  = state.project.getIn(["scenes", action.selectedScene, "workspaceItems", action.id]);
       
        var toMerge = fromJS({animdata : selectedItem.get("animdata"), colors : selectedItem.get("colors"), expression : selectedItem.get("expression"), genderType : selectedItem.get("genderType"), height : selectedItem.get("height"), width : selectedItem.get("width"), pose : selectedItem.get("pose"), src : selectedItem.get("src"), thumbnail : selectedItem.get("thumb"), expFlag : selectedItem.get("expFlag") !== undefined ? selectedItem.get("expFlag") : "", mouthAction : selectedItem.get("mouthAction") !== undefined ? selectedItem.get("mouthAction") : ""});
        var label = action.label.merge(toMerge);
        return label;
      }
    },

   
    "CHANGE_EXPRESSION" : {
      action: function(action, meta) {
        return changeExpression(meta, action.id, action.selectedScene, action.socket)
      },
      createArgs: (state, action) => {
      
        return state.project.getIn(["scenes", action.selectedScene, "workspaceItems", action.id, "expression"]);
      }
    },

    "SET_Z_INDEX" : {
      action: function(action, meta) {
        return updateScene(meta, action.socket)
      },
      createArgs: (state, action) => {
        let toUpdate = {workspaceItems : state.project.getIn(["scenes", action.data.selectedScene, "workspaceItems"])};
        return {selectedScene : action.data.selectedScene, toUpdate : toUpdate};
      }
    },

    "CHANGE_BG" : {
      action: function(action, meta) {
        return updateScene(meta, action.socket)        
      },
      createArgs: (state, action) => {
    
    let selectedScene=action.data.selectedScene;
    let workspaceItems=state.project.getIn(["scenes",selectedScene, "workspaceItems"]);
  
    let workspaceBG = state.project.getIn(["scenes",selectedScene, "workspaceBG"]);
   

    let toUpdate = { workspaceItems : workspaceItems.toJS(),workspaceBG : workspaceBG.toJS()};
      
        return {selectedScene : action.data.selectedScene, toUpdate : toUpdate};
      }
    },

    "DROP_BG" : {
      action: function(action, meta) {
       
        return updateScene(meta, action.socket)
      },
      createArgs: (state, action) => {
    
        let toUpdate = {duration : state.project.getIn(["scenes", action.data.selectedScene, "duration"]), workspaceBG : state.project.getIn(["scenes", action.data.selectedScene, "workspaceBG"])};
        return {selectedScene : action.data.selectedScene, toUpdate : toUpdate};
      }
    },

    "UPDATE_BG" : {
      action: function(action, meta) {
        
        return updateSlide(meta)
      },
      createArgs: (state, action) => {
      
        var selectedScene = action.data.selectedScene;
        var socket = action.socket;
        var value = state.project.getIn(["scenes", selectedScene, "workspaceBG"]);
        return {selectedScene, value, socket, subType : "BG_SETTINGS"};
      }
    },

    "UPDATE_BGCOLOR" : {
      action: function(action, meta) {
        
        return updateSlide(meta)
      },
      createArgs: (state, action) => {
       
        var selectedScene = action.selectedScene;
        var socket = action.socket;
        var value = state.project.getIn(["scenes", selectedScene, "workspaceBG"]);
        return {selectedScene, value, socket, subType : "BG_SETTINGS"};
      }
    },

    "BG_COLOR_SELECTION" : {
      action: function(action, meta) {
        
        return updateScene(meta, action.socket)
      },
      createArgs: (state, action) => {
       
        let toUpdate = {workspaceBG : state.project.getIn(["scenes", action.selectedScene, "workspaceBG"])};
        return {selectedScene : action.selectedScene, toUpdate : toUpdate};
      }
    },

    "BG_GRADIENT_COLORS" : {
      action: function(action, meta) {
        
        return updateScene(meta, action.socket)
      },
      createArgs: (state, action) => {
       
        let toUpdate = {workspaceBG : state.project.getIn(["scenes", action.selectedScene, "workspaceBG"])};
        return {selectedScene : action.selectedScene, toUpdate : toUpdate};
      }
    },


    "DELETE_BG" : {
      action: function(action, meta) {
        return updateSlide(meta)
      },
      createArgs: (state, action) => {
        
        var selectedScene = action.data.selectedScene;
        var socket = action.socket;
        var value = state.project.getIn(["scenes", selectedScene, "workspaceBG"]).toJS();
        return {selectedScene, value, socket, subType : "BG_SETTINGS"};
      }
    },

    "APPLY_FILTER" : {
      action: function(action, meta) {
        return applyFilter(action.active, meta, action.selectedScene, action.socket)
      },
      createArgs: (state, action) => {
       
        var objectData;
        if(action.active !== "BG")
          objectData = state.project.getIn(["scenes", action.selectedScene, "workspaceItems", action.active, "filter"]);
        else
          objectData = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "bgFilter"]);
        
        return objectData;
      }
    },

    
    "CHANGE_OBJECT_END_TIME" : {
      action: function(action, meta) {
        return changeObjectThumb("CHANGE_OBJECT_END_TIME", action.socket, meta, action.id, action.selectedScene);
      },
      createArgs: (state, action) => {
        return state.project.getIn(['scenes', action.selectedScene, 'workspaceItems', action.id, 'exitEnd']);
      }
    },

    "UPDATE_SVGCOLOR" : {
      action: function(action, meta) {
        return updateSVGColor(action.socket, action.id, action.cls, meta, action.selectedScene, action.container);
      },
      createArgs: (state, action) => {
       
        return state.project.getIn(["scenes", action.selectedScene, action.container, action.id, "colors", action.cls]);
      }
    },

    "UPDATE_SVG_THEME" : {
      action: function(action, meta) {
        return updateSVGTheme(action.socket, meta.id, meta.colors, meta.selectedScene, meta.container, meta.isBG);
      },
      createArgs: (state, action) => {
        var selectedScene = action.selectedScene;
        var id = action.id;
        var container = action.container !== undefined?action.container:"workspaceItems";
        var colors = state.project.getIn(["scenes", selectedScene, container, id, "colors"]);
        if(action.isBG)
          colors = state.project.getIn(["scenes", selectedScene, "workspaceBG", "bgColor"]);
        
        return {id, selectedScene, colors, container, isBG : action.isBG };
      }
    },

    "FLIP_ITEM" : {
      action: function(action, meta) {
       
        return flipItem(meta, action.socket);
      },
      createArgs: (state, action) => {
        const selectedScene = action.data.selectedScene;
        const active = action.data.active;
        const flipPosition = state.project.getIn(["scenes", selectedScene, "workspaceItems", active, "flipPosition"]);
        return {selectedScene : selectedScene, active : active, flipPosition : flipPosition};
      }
    },

    "CROP_IMAGE" : {
      action: function(action, meta) {
        return updateObject(meta, action.socket);
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        var selectedItem = action.data.selectedItems.get(0);
        var container = "workspaceItems";
        let item = state.project.getIn(["scenes", selectedScene, container, selectedItem]);
        var toUpdate = {width : item.get("width"), height : item.get("height"), x : item.get("x"), y : item.get("y"), original : item.get("original"), isCropped : item.get("isCropped")};
      
        return {selectedScene, selectedItem, container, toUpdate};
        
      }
    },

    "CROP_BG" : {
      action: function(action, meta) {
       
        return cropBG(meta, action.socket);
      },
      createArgs: (state, action) => {
        const selectedScene = action.data.selectedScene;
        const isVideo = action.data.isVideo;
        const videoId = action.data.videoId;
        const selectedItems = action.data.selectedItems;
        var bgScales = {}, oldData = action.data;
        if (!action.data.isVideo)
        {
          var workspaceBG = state.project.getIn(["scenes", action.data.selectedScene, "workspaceBG"]).toJS();
          bgScales.x = workspaceBG.x;
          bgScales.y = workspaceBG.y;
          bgScales.width = workspaceBG.width;
          bgScales.height = workspaceBG.height;
        }
        else{
          bgScales = state.project.getIn(["videos", action.data.videoId, "bgScales"]).toJS();
        }
       
        return {selectedScene, isVideo, videoId, selectedItems, bgScales};
      }
    },

    "CHANGE_BG_THUMB_VALUE" : {
      action: function(action, meta) {
       
        return changeBGThumbValue("CHANGE_BG_THUMB_VALUE", meta, action.thumbPosition, action.selectedScene, action.socket);
      },
      createArgs: (state, action) => {
        var value;
        if(action.thumbPosition === 'bgStart')
          value = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "enterStart"]);
        else if(action.thumbPosition === 'bgEnd')
          value = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "exitEnd"]); 
        else if(action.thumbPosition === 'bgEnter')
          value = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "enterEnd"]);
        else if(action.thumbPosition === 'bgExit')
          value = state.project.getIn(["scenes", action.selectedScene, "workspaceBG", "exitStart"]);
       
        return value;
      }
    },

    "GROUP_OBJECTS" : {
      action: function(action, meta) {  
        return unGroupObjects(meta, action.socket);
      },
      createArgs: (state, action) => {
        var workspaceChildren = action.data.workspaceChildren;
        var selectedScene = action.data.selectedScene;
       
        var selectedItems = fromJS([action.data.workspaceItems.keySeq().toArray()[0]]);
        var workspaceItemsOrder = {};
         state.project.getIn(["scenes", selectedScene, "workspaceItems"]).entrySeq().forEach(([key,item])=>{
           workspaceItemsOrder[key]=item.get('animIndex');
         })
        
        return {selectedScene : selectedScene, selectedItems : selectedItems, workspaceChildren : workspaceChildren,workspaceItemsOrder:workspaceItemsOrder};
      }
    },

    "UNGROUP_OBJECTS" : {
      action: function(action, meta) {
        return groupObjects(meta, action.socket);
      },
      createArgs: (state, action) => {
        var workspaceChildren = action.data.workspaceChildren;
        var workspaceItems = action.data.workspaceItems;
        var selectedScene = action.data.selectedScene;
       
        var selectedItems = fromJS(action.data.workspaceChildren.keySeq().toArray());
        var workspaceItemsOrder = {};
         state.project.getIn(["scenes", selectedScene, "workspaceItems"]).entrySeq().forEach(([key,item])=>{
           workspaceItemsOrder[key]=item.get('animIndex');
         })
        return {selectedScene : selectedScene, selectedItems : selectedItems, workspaceChildren : workspaceChildren, workspaceItems : workspaceItems,workspaceItemsOrder:workspaceItemsOrder};
      }
    },

    "UPDATE_TIMELINE_DRAG" : {
      action: function(action, meta) {
        if(meta.type === "scene")
          return updateScene({selectedScene : action.selectedScene, toUpdate : meta.toUpdate}, action.socket);
        
      },
      createArgs: (state, action) => {
        let selectedScene = action.selectedScene;
        let type = "scene", toUpdate = {playHeadValue : state.project.getIn(['scenes', selectedScene, 'playHeadValue']), duration : state.project.getIn(['scenes', selectedScene, 'duration']), workspaceItems : state.project.getIn(['scenes', selectedScene, 'workspaceItems']), workspaceChildren : state.project.getIn(['scenes', selectedScene, 'workspaceChildren']), workspaceBG : state.project.getIn(['scenes', selectedScene, 'workspaceBG'])};
        
        return {type, toUpdate};
      }
    },

    "WRITE_TEXT" : {
      action: function(action, meta) {
      
          return writeText(meta, action.socket);
      },
      createArgs: (state, action) => {
        
          let selectedScene = action.data.selectedScene;
          let selectedItem = action.data.selectedItem;
          let container = action.data.container;
          let toUpdate = fromJS({});
          let item = state.project.getIn(["scenes", selectedScene, container, selectedItem]);
            for(var key in action.data.toUpdate){
              toUpdate = toUpdate.set(key, item.get(key));
            }
            toUpdate = toUpdate.toJS();
              toUpdate.width = item.get("width");
              toUpdate.height = item.get("height");
              toUpdate.x = item.get("x");
              toUpdate.y = item.get("y");
           
            return {selectedScene, selectedItem, container, toUpdate, isTyping : action.data.isTyping, undo : true};
       
      }
    },

    "UPDATE_GROUP_TEXT" : {
      action: function(action, meta) {
          return undoMove(meta);
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        var groupId = action.data.groupId, currentId = action.data.currentId, currentContainer = "workspaceItems", socket = action.socket;

        var childIds = state.project.getIn(["scenes", selectedScene, "workspaceItems", groupId, "groupChildren"]);
        var children = state.project.getIn(["scenes", selectedScene, "workspaceChildren"]).filter(function(obj, key){return childIds.keyOf(key) !== undefined;});
        var workspaceItems    = fromJS({});
        var workspaceChildren = fromJS({});

        if(action.data.isGrouped){
          children.entrySeq().forEach(([key, item]) => {
              workspaceChildren = workspaceChildren.setIn([key, "y"], item.get("y"));
              workspaceChildren = workspaceChildren.setIn([key, "height"], item.get("height"));
              if(key === currentId &&action.data.textData !== undefined)
                workspaceChildren = workspaceChildren.setIn([key, "textData"], item.get("textData"));
          });

          workspaceItems = workspaceItems.setIn([groupId, "y"], state.project.getIn(["scenes", selectedScene, "workspaceItems", groupId, "y"]));
          workspaceItems = workspaceItems.setIn([groupId, "height"], state.project.getIn(["scenes", selectedScene, "workspaceItems", groupId, "height"]));
        }
    
        return {selectedScene, workspaceItems, workspaceChildren, currentContainer, socket};
       
      }
    },

    "UPDATE_ITEM" : {
      action: function(action, meta) {
          return updateObject(meta, action.socket);
      },
      createArgs: (state, action) => {
        let selectedScene = action.data.selectedScene;
        let selectedItem = action.data.selectedItem;
        let container = action.data.container;
        let toUpdate = fromJS({});
          for(var key in action.data.toUpdate){
            toUpdate = toUpdate.set(key, state.project.getIn(["scenes", selectedScene, container, selectedItem, key]));
          }
          toUpdate = toUpdate.toJS();
          
          return {selectedScene, selectedItem, container, toUpdate};
       
      }
    },

    "PASTE_ITEMS" : {
      action: function(action, meta) {
        if(action.data.dataType === "ITEMS"){
          return updateScene(meta, action.socket)
        }
        else if (action.data.dataType === "SCENES"){
          return undoScenePaste(meta, action.socket);
        }
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        var toReturn = {};
        if(action.data.dataType === "ITEMS"){
          toReturn = {selectedScene, toUpdate : {workspaceItems : state.project.getIn(["scenes", selectedScene, "workspaceItems"]).toJS(), workspaceChildren : state.project.getIn(["scenes", selectedScene, "workspaceChildren"]).toJS()}};
        }else if (action.data.dataType === "SCENES"){
          let scenes = state.project.get("scenes").toJS();
          toReturn = {toUpdate : {scenes : scenes}, selectedScene : selectedScene}
        }
        
        return toReturn;
      }
    },

    "ADD_PREBUILT" : {
      action: function(action, meta) {
        if(meta.addAll || meta.replace)
          return addPrebuilt(meta, action.socket)
        else{
          if(!meta.addAll)
            return removeScene(meta.selectedScene + 1, action.socket);
        }
      },
      createArgs: (state, action) => {
      
        let selectedScene = action.data.selectedScene;
        let addAll = action.data.addAll;
        let replace = action.data.replace;
        let undo = true;
        let prebuilt;

        if(addAll !== true){
          if(replace)
            prebuilt = state.project.getIn(["scenes", state.localStore.get("selectedScene")]);
         
        }else{
            prebuilt = fromJS({project : state.project});
        }
       
        return { selectedScene, prebuilt, addAll, replace, undo};

      }
    },

    "APPLY_ENTER_EFFECT" : {
      action: function(action, meta) {
              return applyEnterEffect(meta, action.socket);
      },
      createArgs: (state, action) => {
        let {effectData,selectedScene} = action.data;
        const sceneEffectData = {};
        if(effectData.isapplyToallSlides){
          state.project.getIn(['scenes']).entrySeq().forEach(([key,item])=>{
            sceneEffectData[key] = {};
            state.project.getIn(['scenes',key,'workspaceItems']).entrySeq().forEach(([wKey, wItem]) =>{
              sceneEffectData[key][wKey]= wItem.get('enterEffectName')
            });
          })    
        }
        else{
        sceneEffectData[selectedScene]={}
        state.project.getIn(['scenes',selectedScene,'workspaceItems']).entrySeq().forEach(([key, item]) =>{
          sceneEffectData[selectedScene][key]= item.get('enterEffectName')
        });
      }
      return {effectData:effectData,sceneEffectData,isUndo:true};
      }
    },

    'ADD_LINK_TO_TEXT':{
      action: function(action, meta) {
      
        return updateObject(meta, action.socket)
      },
      createArgs: (state, action) => {
       
        var selectedScene = action.data.selectedScene;
        var selectedItem = action.data.selectedItem;
        var container = action.data.container;
        let item = state.project.getIn(["scenes", selectedScene, container, selectedItem]);
        var toUpdate = {textData : item.get("textData").toJS(), width : item.get("width"), height : item.get("height")};

        if(item.get("yRatio") !== undefined)
          toUpdate.yRatio = item.get("yRatio");
        if(item.get("heightRatio") !== undefined)
          toUpdate.yRatio = item.get("heightRatio");
      
        return {selectedScene, selectedItem, container, toUpdate};
      }
     
    },

    "ADD_LINK_TO_OBJ" : {
      action: function(action, meta) {
        return updateObject(meta, action.socket);
      },
      createArgs: (state, action) => {
        var selectedScene = action.data.selectedScene;
        var selectedItem = action.data.selectedItem;
        var container = "workspaceItems";
        let item = state.project.getIn(["scenes", selectedScene, container, selectedItem]);
        var toUpdate = {link:item.get('link')};
      
        return {selectedScene, selectedItem, container, toUpdate};
        
      }
    },
    
    'APPLY_ALL_TRANSITION' : {
      action: function(action, meta) { 
        return applyAllTransition(meta,action.socket)
       
      },
      createArgs: (state, action) => {
        const sceneTransData = [];
        for(let i=0;i<state.project.get('scenes').size-1;i++){
          const scene = state.project.getIn(['scenes', i]);
          sceneTransData.push({selectedScene:state.project.getIn(['scenes', i]) , toUpdate:{'transColor':scene.get('transColor')? scene.get('transColor'):{}, 'transEffect':scene.get('transEffect'), 'sizes':scene.get('sizes')}})
       }
       
        return {sceneTransData , isUndo:true};
      }
    },

    'SET_ANIMATE_VALUE' : {
      action: function(action, meta) { 
        return setAnimateValue(meta,action.socket)
       
      },
      createArgs: (state, action) => {
        const {selectedScene,container,selectedItem} = action.data;
        const animateData = state.project.getIn(['scenes',selectedScene,container,selectedItem,'animType']);
        return { selectedScene , container , selectedItem , animateData}
      }
    }

  }
})



// WEBPACK FOOTER //
// ./src/undoMiddleware.js